import {
  type Layer,
  type StandardChartLayerSpec,
  defineStandardChartLayer
} from '../../../core/layer';
import DEFINE from '../../../util/DEFINE';

const visInfo: Layer['visInfo'] = {
  id: 'tree',
  name_zh: '树图',
  name_en: 'Tree',
  types_en: [],
  purpose_en: [],
  purpose_zh: [],
  standers: '',
  rules: {},
  /** 保证和 Spec.encoding 字段一致 */
  parameters: {}
};

/** 暂不支持legend的点击功能 */
export interface Spec extends StandardChartLayerSpec {}

export const tree = defineStandardChartLayer<Spec>({
  type: visInfo.id,
  isIndependentLayer: true,
  visInfo,
  render(api, spec) {
    const { data: dataArray } = api;
    const { dataIndex = 0 } = spec;
    const data = dataArray[dataIndex];

    return {
      tooltip: {
        trigger: 'item',
        triggerOn: 'mousemove'
      },
      legend: {
        data: []
      },
      name: 'tree',
      xAxis: [],
      yAxis: [],
      series: [
        {
          type: 'tree',
          data: [data.values]
        }
      ]
    };
  }
});
